import { useEffect, useSyncExternalStore } from 'react'
// OrgContext is an untyped .jsx module (runtime-resolved by the customer build); the strict customer-build tsc otherwise
// flags TS7016 on this .ts importer. useOrg() returns the org context ({ org: { id }, ... }); `org` is read below.
// @ts-expect-error -- untyped .jsx context module (TS7016); resolved at runtime by the customer build
import { useOrg } from '../context/OrgContext'
import { orgAPI } from '../services/api'

/**
 * The signed-in organization's own logo (GET /api/org/logo), shared by every place that shows it: the menu's
 * organization card, the org chart and Settings. One read per organization; Settings' upload or removal updates every
 * place at once.
 */
let state: { orgId: string | null; logo: string | null } = { orgId: null, logo: null }
const listeners = new Set<() => void>()
const set = (next: typeof state) => {
  state = next
  listeners.forEach((l) => l())
}
const subscribe = (l: () => void) => {
  listeners.add(l)
  return () => listeners.delete(l)
}
let loading: string | null = null

/** The current organization's logo as a data URL, or null (none, or not read yet). */
export function useOrgLogo() {
  const { org } = useOrg()
  const orgId: string | null = org?.id ?? null
  const current = useSyncExternalStore(subscribe, () => state)
  useEffect(() => {
    if (!orgId || state.orgId === orgId || loading === orgId) return
    loading = orgId
    orgAPI
      .getLogo()
      .then((res) => set({ orgId, logo: res?.data?.logo ?? null }))
      // No logo can be read: the initial shows, as for an organization without one.
      .catch(() => set({ orgId, logo: null }))
      .finally(() => { if (loading === orgId) loading = null })
  }, [orgId])
  return current.orgId === orgId ? current.logo : null
}

/** After Settings saves or removes the logo. */
export function setOrgLogo(orgId: string | null, logo: string | null) {
  set({ orgId, logo })
}
